module.exports = __webpack_public_path__ + "media/wyposazenie/skrzynia-biegow-f197d7cd.png";